import { EntityTypeEnumType } from '@mark43/cad-api';

interface NavigateToBoloParams {
    navigateToBolo: (boloId: number) => void;
    navigateToEvent: (eventId: number) => void;
    currentEntityType: 'BOLO' | 'EVENT';
    currentEntityId?: number;
}

type OnClickLinkArgs = { entityType: EntityTypeEnumType; boloId: number; entityId: number };

export const useNavigateToBoloOrEvent = ({
    navigateToEvent,
    navigateToBolo,
    currentEntityType,
    currentEntityId,
}: NavigateToBoloParams) => {
    const onClickLinkForEventPanel = (args: OnClickLinkArgs) => {
        const { boloId } = args;
        navigateToBolo(boloId);
    };

    const onClickLinkForBoloPanel = (args: OnClickLinkArgs) => {
        const { entityType, entityId, boloId } = args;
        if (entityType === 'BOLO') {
            navigateToBolo(currentEntityId === boloId ? entityId : boloId);
        } else {
            navigateToEvent(entityId);
        }
    };

    const onClickLink = (args: OnClickLinkArgs) => {
        if (currentEntityType === 'EVENT') {
            onClickLinkForEventPanel(args);
        } else {
            onClickLinkForBoloPanel(args);
        }
    };

    return { onClickLink };
};
